import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'isArrayValid',
})
export class IsArrayValidPipe implements PipeTransform {
  transform(value: any[], ..._args: any[]): boolean {
    if (value == undefined || value == null || !(value.length > 0)) {
      return true;
    } else {
      return false;
    }
  }
}
